import _ from 'lodash';

export default function isDataArray(obj: any) {
  return _.isArrayBuffer(obj) || _.isTypedArray(obj);
}
